import {
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { Dialog } from './EditListDialog.style'
import { Close } from 'shared/assets'

interface EditListDialogProps {
  open: boolean
  onClose: () => void
  children: JSX.Element
  disableClose?: boolean
  onExited?: () => void
}

const EditListDialog = ({
  open,
  onClose,
  children,
  disableClose = false,
  onExited,
}: EditListDialogProps) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog
      open={open}
      onClose={disableClose ? undefined : onClose}
      fullScreen={fullScreen}
      disableEscapeKeyDown={disableClose}
      TransitionProps={{ onExited }}
    >
      <DialogTitle textAlign="end">
        <IconButton onClick={onClose} disabled={disableClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  )
}

export default EditListDialog
